import { clsx } from 'clsx';
import { cva } from 'class-variance-authority';
import { Flex, Text, Button } from '@nula/core-ui';
import { useAuthStore } from '@/stores/use-auth-store';
import styles from './account-footer.module.css';

const root = cva(styles.root);

interface AccountFooterProps {
  onLogout: () => void;
  className?: string;
}

export function AccountFooter({ onLogout, className }: AccountFooterProps) {
  const email = useAuthStore((s) => s.user?.email ?? '');
  return (
    <Flex align="center" className={clsx(root(), className)}>
      <Flex vertical gap="xs">
        <Text type="secondary" className={styles.line}>
          Signed in as <span className={styles.email}>{email}</span>
        </Text>
        <Button variant="text" size="sm" onClick={onLogout} className={styles.logout}>
          Log in as someone else
        </Button>
      </Flex>
      <Text type="secondary" className={styles.org}>Nula Labs, Inc</Text>
    </Flex>
  );
}
